import { Typo } from "../Typo";

export const ProgressLoader = ({
  value = 0,
  height = 80,
  width = 80,
  progressStrokeWidth,
  progressColor = "text-icon-brand-default",
  backgroundProgressColor = "text-icon-disabled",
  textColor = "text-text-primary",
  textClasses = "",
}: {
  value?: number;
  height?: number;
  width?: number;
  backgroundProgressColor?: string;
  progressColor?: string;
  progressStrokeWidth?: number;
  textColor?: string;
  textClasses?: string;
}) => {
  const minDimension = Math.min(width, height);
  const radius = (minDimension / 2) * 0.9;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;
  const centerX = width / 2;
  const centerY = height / 2;

  // Make stroke width relative to size if not provided
  const responsiveStrokeWidth =
    progressStrokeWidth ?? Math.max(2, minDimension * 0.08);

  return (
    <div
      className="relative"
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <svg
        style={{ width: `${width}px`, height: `${height}px` }}
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="xMidYMid meet"
      >
        {/* Background circle */}
        <circle
          cx={centerX}
          cy={centerY}
          r={radius}
          stroke="currentColor"
          strokeWidth={responsiveStrokeWidth}
          strokeLinecap="round"
          fill="transparent"
          className={backgroundProgressColor}
          vectorEffect="non-scaling-stroke"
        />
        {/* Progress circle */}
        <circle
          cx={centerX}
          cy={centerY}
          r={radius}
          stroke="currentColor"
          strokeWidth={responsiveStrokeWidth}
          strokeLinecap="round"
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={`transition-all duration-500 ease-in-out ${progressColor}`}
          vectorEffect="non-scaling-stroke"
          transform={`rotate(-90 ${centerX} ${centerY})`}
        />
      </svg>
      <Typo
        element="span"
        type="labelMD"
        classes={`absolute inset-0 flex items-center justify-center ${textClasses}`}
        textColor={textColor}
      >
        {`${value}%`}
      </Typo>
    </div>
  );
};
